export const enum EStatus {
    ready = 'ready',
    loading = 'loading',
    success = 'success',
    failure = 'failure',
}
